var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"table-summary",attrs:{"justify":"start","no-gutters":""}},_vm._l((_vm.items),function(item,index){return _c('v-col',{key:index},[_c('span',[_c('strong',[_vm._v(_vm._s(item.label)+": ")]),_vm._v(_vm._s(_vm.formattedValue(item.value))+" ")])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }